// English translations
import enCommon from './en/common.json';
import enAdmin from './en/admin.json';
import enNative from './en/native.json';
import enErrors from './en/errors.json';

// Spanish translations
import esCommon from './es/common.json';
import esAdmin from './es/admin.json';
import esNative from './es/native.json';
import esErrors from './es/errors.json';

export const enTranslations = {
  common: enCommon,
  admin: enAdmin,
  native: enNative,
  errors: enErrors,
} as const;

export const esTranslations = {
  common: esCommon,
  admin: esAdmin,
  native: esNative,
  errors: esErrors,
} as const;

export const resources = {
  en: enTranslations,
  es: esTranslations,
} as const;

export type SupportedLanguage = keyof typeof resources;
export type Namespace = keyof typeof enTranslations;

export const supportedLanguages: SupportedLanguage[] = ['en', 'es'];
export const defaultLanguage: SupportedLanguage = 'en';
export const defaultNamespace: Namespace = 'common';

export const languageNames: Record<SupportedLanguage, string> = {
  en: 'English',
  es: 'Español',
};
